export const UnitMap = [
  { ml: " ml" },
  { g: " g" },
  { kg: " kg" },
  { mg: " mg" },
  { l: " l" },
];
